"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

var _emailConfig = require("@/api/emailConfig");

var _selectConsultModel = _interopRequireDefault(require("../components/selectConsultModel.vue"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Secondary package based on el-pagination
var vm;
var _default = {
  name: "emailConfig",
  components: {
    selectConsultModel: _selectConsultModel.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      dialogViewVisible: false,
      logList: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
        sort: 'create_time',
        order: 'desc'
      },
      listLoading: true,
      timeOptions: ['01:00:00', '02:00:00', '03:00:00', '04:00:00', '05:00:00', '06:00:00', '07:00:00', '08:00:00', '09:00:00'],
      typeOptions: [{
        id: "婴幼儿",
        name: '婴幼儿'
      }, {
        id: "儿童奶粉",
        name: '儿童奶粉'
      }, {
        id: "成人",
        name: '成人'
      }, {
        id: "鲜奶",
        name: '鲜奶'
      }, {
        id: "UHT",
        name: 'UHT'
      }],
      emailConfig: {
        id: undefined,
        name: "",
        mailTitle: "",
        mailTo: "",
        deleted: false,
        items: []
      },
      emailIndex: '',
      dialogAdminVisible: false,
      deletedOptions: [{
        value: false,
        label: "正常"
      }, {
        value: true,
        label: "删除"
      }],
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "创建"
      },
      rules: {
        name: [{
          required: true,
          message: "名称不能为空",
          trigger: "blur"
        }],
        mailTitle: [{
          required: true,
          message: "发送邮件标题不能为空",
          trigger: "blur"
        }],
        mailTo: [{
          required: true,
          message: "邮件接收人不能为空",
          trigger: "blur"
        }],
        mailTime: [{
          required: true,
          message: "邮件发送时间不能为空",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleViewLog: function handleViewLog() {
      var _this = this;

      this.dialogViewVisible = true;
      this.listLoading = true;
      (0, _emailConfig.logList)(this.listQuery).then(function (res) {
        _this.logList = res.data.data.list;
        _this.total = res.data.data.total;
        _this.listLoading = false;
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;
      (0, _emailConfig.listEmailConfig)().then(function (response) {
        var data = response.data.data;

        if (data && data.items) {
          data.items.forEach(function (item) {
            item.pType = item.pType.split(',');
          });
        }

        _this2.emailConfig = data;
        _this2.listLoading = false;
      }).catch(function () {
        _this2.emailConfig = {};
        _this2.listLoading = false;
      });
    },
    handleConsultSelect: function handleConsultSelect(index) {
      var _this3 = this;

      this.emailIndex = index;
      this.$nextTick(function () {
        _this3.$refs.selectConsultModel.show(1, null, 1);
      });
    },
    handleSelectedConsult: function handleSelectedConsult(selectedValue, selected) {
      console.info(selectedValue);

      for (var i = 0; i < this.emailConfig.items.length; i++) {
        if (i == this.emailIndex) {
          this.emailConfig.items[i].consultName = selected.join('');
          this.emailConfig.items[i].consultId = selectedValue.join('');
          return;
        }
      }
    },
    handleAddItem: function handleAddItem() {
      for (var i = 0; i < this.emailConfig.items.length; i++) {
        var item = this.emailConfig.items[i];
        console.info(item);

        if (!item.consultId || !item.pType || !item.cntFirst || item.cntSecond == null || !item.cntIncrement) {
          this.$notify.warning({
            title: '提醒',
            message: '请将上一项填写完整'
          });
          return;
        }
      }

      this.emailConfig.items.push({
        cntFirst: '10',
        cntSecond: '10',
        cntIncrement: '10',
        consultName: '',
        consultId: ''
      });
    },
    createData: function createData() {
      var _this4 = this;

      if (this.emailConfig.items.length == 0) {
        this.$notify.warning({
          title: '提醒',
          message: '请至少选择一个咨询项'
        });
        return;
      }

      for (var i = 0; i < this.emailConfig.items.length; i++) {
        var item = this.emailConfig.items[i];

        if (!item.consultId || !item.pType || !item.cntFirst || item.cntSecond == null || !item.cntIncrement) {
          this.$notify.warning({
            title: '提醒',
            message: '请将咨询配置填写完整'
          });
          return;
        }
      }

      this.$refs["emailConfig"].validate(function (valid) {
        if (valid) {
          var param = JSON.parse(JSON.stringify(_this4.emailConfig));
          param.items.forEach(function (item) {
            item.pType = item.pType.join(',');
          });
          console.info(param);
          (0, _emailConfig.createEmailConfig)(param).then(function (response) {
            _this4.$notify.success({
              title: "成功",
              message: "邮件设置成功"
            });
          }).catch(function (response) {
            _this4.$notify.error({
              title: "失败",
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleLog: function handleLog(row) {//查看发送日志
    }
  }
};
exports.default = _default;